import { MenuItem, MenuList } from '@mui/material';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

import { MainLink } from 'types';
import { isMainNavActive } from 'utils/isMainNavActive';

export interface MenuNavLinksProps {
    links: MainLink[];
}

const MenuNavLinks: React.FC<MenuNavLinksProps> = ({ links }) => {
    const { pathname } = useLocation();
    const allPaths = links.map((link) => link.path);

    return (
        <MenuList
            component="nav"
            dense
            disablePadding
            sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}
        >
            {links.map((link) => {
                const isActive = isMainNavActive(pathname, link.path, allPaths);

                return (
                    <MenuItem
                        key={link.path}
                        component={RouterLink}
                        to={link.path}
                        selected={isActive}
                        disableRipple
                        sx={{
                            px: 2,
                            py: 1,
                            minWidth: 'auto',
                            borderRadius: 2,
                            color: isActive ? 'primary.main' : 'text.primary',
                            bgcolor: isActive ? 'action.selected' : 'transparent',
                            fontWeight: isActive ? 'fontWeightBold' : 'fontWeightMedium',
                            transition: 'background-color 150ms ease',
                            '&:hover': {
                                bgcolor: 'action.hover',
                            },
                        }}
                    >
                        {link.name}
                    </MenuItem>
                );
            })}
        </MenuList>
    );
};

export default MenuNavLinks;
